import auth from "../helper/middleware/auth";
import dataSubmission from "../helper/middleware/dataSubmission";
export default [
  {
    path: "/documents",
    redirect: "/documents/list",
    meta: { middleware: [auth] },
    children: [
      {
        path: "check",
        name: "checkLegality",
        component: () => import("@/views/documents/CheckLegality.vue"),
      },
      {
        path: "list/:id?",
        name: "documents",
        component: () => import("@/views/documents/MyDocumentsView.vue"),
        props: true,
      },
      {
        path: "recycle-bin",
        name: "recycleBin",
        component: () => import("@/views/documents/RecycleBinView.vue"),
      },
      {
        path: "totp-activation",
        name: "totpActivation",
        component: () => import("@/views/documents/TotpActivationView.vue"),
      },
      {
        path: "need-e-sign",
        name: "needSignElectronic",
        component: () => import("@/views/documents/NeedSignView.vue"),
      },
      {
        path: "need-digital-sign",
        name: "needSignDigital",
        component: () => import("@/views/documents/NeedSignView.vue"),
      },
      {
        path: "signed",
        name: "signed",
        component: () => import("@/views/documents/SignedView.vue"),
      },
      {
        path: ":id",
        redirect: "detailDocument",
        children: [
          {
            path: "",
            name: "detailDocument",
            component: () => import("@/views/documents/DetailDocumentView.vue"),
            props: true,
            meta: { middleware: [dataSubmission, auth] },
          },
        ],
      },
    ],
  },
];
